var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnemployed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0019 21.0039H6.99776C4.7877 21.0039 2.99609 19.2123 2.99609 17.0022V8.99888C2.99609 7.89385 3.8919 6.99805 4.99693 6.99805H19.0028C20.1078 6.99805 21.0036 7.89385 21.0036 8.99888V17.0022C21.0036 19.2123 19.212 21.0039 17.0019 21.0039Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99805 6.99825V4.99742C7.99805 3.89239 8.89385 2.99658 9.99888 2.99658H14.0005C15.1056 2.99658 16.0014 3.89239 16.0014 4.99742V6.99825",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.99805,
    y: 10.9995,
    width: 4.00167,
    height: 3.00125,
    rx: 0.5,
    stroke: "#DCE3F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.5002H19.5015C21.4353 12.5002 23.0029 10.9326 23.0029 8.99878",
    stroke: "#DCE3F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99901 12.5005H4.49755C2.56375 12.5005 0.996094 10.9328 0.996094 8.99902",
    stroke: "#DCE3F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5074 18.3249C25.5074 15.2582 23.022 12.7727 19.9558 12.7727C16.8889 12.7727 14.4035 15.2588 14.4035 18.3249C14.4035 21.3912 16.8897 23.8765 19.9558 23.8765C23.022 23.8765 25.5074 21.3911 25.5074 18.3249Z",
    fill: "#3158F2",
    stroke: "#DCE3F7",
    strokeWidth: 1.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8586 16.4229L18.0547 20.2268",
    stroke: "#DCE3F7",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8586 20.2268L18.0547 16.4229",
    stroke: "#DCE3F7",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnemployed);
export default __webpack_public_path__ + "static/media/unemployed.65de4a00e3af4bf6b8e55b138b84967c.svg";
export { ForwardRef as ReactComponent };